export function UpdateBanner() {
  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3
      bg-accent text-white px-5 py-3 rounded-2xl shadow-xl text-sm font-medium
      animate-fade-in pointer-events-auto">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.3"/>
      </svg>
      New version available
      <button
        onClick={() => window.location.reload()}
        className="bg-white/25 hover:bg-white/40 px-3 py-1 rounded-xl transition-colors font-semibold"
      >
        Update
      </button>
    </div>
  )
}
